import { Logo as n } from "./index.js";
class s extends n {
  htmlContent;
  constructor(t, o = "") {
    super(t), this.htmlContent = o;
  }
}
export {
  s as LogoWithHtmlContent
};
//# sourceMappingURL=index3.js.map
